import createDomainListReduxUtil from '../../redux/utils/create-domain-list'

export const MEALS_DOMAIN = 'meals'

export const MEALS_KEY = {
  ALL: 'all',
  DATA: 'data',
  LOGGED: 'logged',
  NON_LOGGED: 'nonLogged',
  NON_LOGGED_AND_PLANNED: 'nonLoggedAndPlanned',
  PLANNED: 'planned',
  CURRENT: 'current',
  RECOMMENDED: 'recommended',
  DOWNLOADED: 'downloaded',
  HAS_SEEN_SCAN_MEAL_INTRO: 'hasSeenScanMealIntro'
}

export const MEALS_PATH = {
  ALL: `${MEALS_DOMAIN}.${MEALS_KEY.ALL}`,
  ALL_DATA: `${MEALS_DOMAIN}.${MEALS_KEY.ALL}.data`,
  DATA: `${MEALS_DOMAIN}.${MEALS_KEY.DATA}`,
  CURRENT: `${MEALS_DOMAIN}.${MEALS_KEY.CURRENT}`,
  LOGGED: `${MEALS_DOMAIN}.${MEALS_KEY.LOGGED}`,
  LOGGED_DATA: `${MEALS_DOMAIN}.${MEALS_KEY.LOGGED}.data`,
  NON_LOGGED: `${MEALS_DOMAIN}.${MEALS_KEY.NON_LOGGED}`,
  NON_LOGGED_DATA: `${MEALS_DOMAIN}.${MEALS_KEY.NON_LOGGED}.data`,
  PLANNED: `${MEALS_DOMAIN}.${MEALS_KEY.PLANNED}`,
  PLANNED_DATA: `${MEALS_DOMAIN}.${MEALS_KEY.PLANNED}.data`,
  NON_LOGGED_AND_PLANNED: `${MEALS_DOMAIN}.${MEALS_KEY.NON_LOGGED_AND_PLANNED}`,
  NON_LOGGED_AND_PLANNED_DATA: `${MEALS_DOMAIN}.${MEALS_KEY.NON_LOGGED_AND_PLANNED}.data`,
  RECOMMENDED: `${MEALS_DOMAIN}.${MEALS_KEY.RECOMMENDED}`,
  RECOMMENDED_DATA: `${MEALS_DOMAIN}.${MEALS_KEY.RECOMMENDED}.data`,
  DOWNLOADED: `${MEALS_DOMAIN}.${MEALS_KEY.DOWNLOADED}`,
  HAS_SEEN_SCAN_MEAL_INTRO: `${MEALS_DOMAIN}.${MEALS_KEY.HAS_SEEN_SCAN_MEAL_INTRO}`
}

export const MEALS_STATE = {
  [MEALS_KEY.ALL]: createDomainListReduxUtil(),
  [MEALS_KEY.LOGGED]: createDomainListReduxUtil(),
  [MEALS_KEY.NON_LOGGED_AND_PLANNED]: createDomainListReduxUtil(),
  [MEALS_KEY.NON_LOGGED]: createDomainListReduxUtil(),
  [MEALS_KEY.PLANNED]: createDomainListReduxUtil(),
  [MEALS_KEY.RECOMMENDED]: createDomainListReduxUtil(),
  [MEALS_KEY.DOWNLOADED]: createDomainListReduxUtil(),
  [MEALS_KEY.CURRENT]: null,
  [MEALS_KEY.HAS_SEEN_SCAN_MEAL_INTRO]: null,
  [MEALS_KEY.DATA]: {}
}

const ROOT = '/meals'
export const MEALS_ENDPOINT = {
  ROOT,
  MEAL_BY_ID: `${ROOT}/:id`,
  EDIT_RESULTS: `${ROOT}/:id/edit-results`
}
